export const MAX_PICKER_ITEMS = 6

export const COLS_CLASS_DEFAULT = 'grid-cols-3'
export const COLS_CLASS_OVERRIDES = {
  recommended_variants: 'grid-cols-2',
}
